import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const arDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    //viewBtn: true,
    columnBtn: false,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "应收款编号",
            prop: "number",
            search: true,
            type: 'input'
        },
        {
            label: "采购订单编号",
            prop: "businessNumber",
            type: "input",
        },
        {
            label: "账号",
            prop: "account",
            type: 'input',
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input",
        },

        {
            label: "采购时间",
            prop: "purchaseTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "采购时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        },
        {
            label: "应收款状态",
            prop: "status",
            type: "select",
            search: true,
            dicData: DIC.NEW_STOCK_AR_STATUS
        },
        {
            label: "支付时间",
            prop: "payTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            formatter: function (row, value, label, column) {
                if (row.payTime != 0) {
                    return row.payTime
                }
            },
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: "应收款总计金额",
            prop: "money",
            type: "input",
        },
        {
            label: "支付时间区间",
            prop: "payTimeInterval",
            type: "datetimerange",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },

    ]
};